// extracted by mini-css-extract-plugin
export default {"container":"projects_container__EEA+J","table":"projects_table__AD6XA","year":"projects_year__21YkC"};